/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthScheduledEvents
 */
export interface TenantHealthScheduledEvents {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthScheduledEvents
     */
    pending_overdue?: number;
}

/**
 * Check if a given object implements the TenantHealthScheduledEvents interface.
 */
export function instanceOfTenantHealthScheduledEvents(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthScheduledEventsFromJSON(json: any): TenantHealthScheduledEvents {
    return TenantHealthScheduledEventsFromJSONTyped(json, false);
}

export function TenantHealthScheduledEventsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthScheduledEvents {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pending_overdue': !exists(json, 'pending_overdue') ? undefined : json['pending_overdue'],
    };
}

export function TenantHealthScheduledEventsToJSON(value?: TenantHealthScheduledEvents | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pending_overdue': value.pending_overdue,
    };
}

